/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { UseFormMethods } from 'react-hook-form';
import { EmailAgentSubmissionProps } from '../EmailAgentForm.types';

const useCaptcha = (
    show: boolean,
    form: UseFormMethods<EmailAgentSubmissionProps>,
    errorCopy: string
) => {
    useEffect(() => {
        if (show) {
            form.register({ name: 'captchaToken' }, { required: errorCopy });
        } else {
            form.unregister('captchaToken');
        }
    }, [show]);

    const onCaptchaChange = (token: string | null) => {
        // Save the token value directly to react-hook-form
        form.setValue('captchaToken', token);

        // Trigger react-hook-form re-validation
        form.trigger('captchaToken');
    };

    return {
        onCaptchaChange
    };
};

export default useCaptcha;
